
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index4bltJFlbhuX3ZuGyJ29SQmU3A8aiydeV8oi9ELKj1g4Meta } from "/codebuild/output/src3853497092/src/pages/index.vue?macro=true";
import { default as indexKNf378OmptHnQTyvp3Q0hfVu7QEcQOHkqHpEMh9FdxEMeta } from "/codebuild/output/src3853497092/src/pages/login/index.vue?macro=true";
import { default as index30uvTp4afptyuoXixYroudma6NLLEvVF4tPxY2TH_45yYMeta } from "/codebuild/output/src3853497092/src/pages/software/index.vue?macro=true";
import { default as indexlJQZ_45_45PHvQRLALufqrFks8hn_45gSdV6uwaRzr2HX7nSIMeta } from "/codebuild/output/src3853497092/src/pages/trackers/index.vue?macro=true";
import { default as indexE0WGDzz7bbxlXWTmsl5k6jUNI1_45VRvkZTzd_45HWLBqcIMeta } from "/codebuild/output/src3853497092/src/pages/templates/index.vue?macro=true";
import { default as createxRJulHYIXXntYpWlv3AqYlquyqh35XjypNLn0KPTZmEMeta } from "/codebuild/output/src3853497092/src/pages/trackers/create.vue?macro=true";
import { default as createdkhRuf96IRV8gdvZSFIN9MgoLo28igcrHhuUIEJhGhwMeta } from "/codebuild/output/src3853497092/src/pages/templates/create.vue?macro=true";
import { default as indexqldQqOkcQ1wyvidlgVAEAx0Sg_WfAMf7qjkeQYbiwQEMeta } from "/codebuild/output/src3853497092/src/pages/tagging-docs/index.vue?macro=true";
import { default as editsFMEdF3ohi4TfsLpQSX4D_45TlUwXiyERkLKVRUHhF7fAMeta } from "/codebuild/output/src3853497092/src/pages/trackers/[id]/edit.vue?macro=true";
import { default as _91token_93val9Y5MtOwpM7_U0ZhEW1e0LPI6abKz0Eu4VWBanhNkMeta } from "/codebuild/output/src3853497092/src/pages/login/token/[token].vue?macro=true";
import { default as editkdv8bUCPuej_MzNMbtribKO_4532NsmStqCObo8S6X1YEMeta } from "/codebuild/output/src3853497092/src/pages/templates/[id]/edit.vue?macro=true";
import { default as indexmD8VjPrOmNt96mu5LXcrxZlX91mf7Yjzf_45aLic_apREMeta } from "/codebuild/output/src3853497092/src/pages/templates/[id]/index.vue?macro=true";
import { default as indexNpMbAWpdc4taM_45iN56MD6NLcyXKufl2regMsTa165uYMeta } from "/codebuild/output/src3853497092/src/pages/plan-management/index.vue?macro=true";
import { default as indexQ2efC9kD_g_yf_yl1_XbDMmxNG5_45EI0_457aKbAvjzBkcMeta } from "/codebuild/output/src3853497092/src/pages/dropcode-generator/index.vue?macro=true";
import { default as indexjC4xHpx4Qh7bicezrU2PyUXJjgm8JyO9uwtQmz1_9AwMeta } from "/codebuild/output/src3853497092/src/pages/standalone-snowplow/index.vue?macro=true";
import { default as indexaAsIH3W60lxQEgNX7aZr4aiqH88DtelopkWEcblF3qUMeta } from "/codebuild/output/src3853497092/src/pages/trackers/[id]/events/index.vue?macro=true";
import { default as indexbZqbDcdU6eqsCu4P_gGo_45A97q75etDC8Qais7NeuK9YMeta } from "/codebuild/output/src3853497092/src/pages/plan-management/[id]/events/index.vue?macro=true";
import { default as create8l0qMRw_45fNawLDGwnxZV4kfMOnRNev2_45A5wk2XgaqyQMeta } from "/codebuild/output/src3853497092/src/pages/plan-management/[id]/events/create.vue?macro=true";
import { default as editylEezE8a62G645PzgIMmvse8DjLl16Z4DdDShd5rAIkMeta } from "/codebuild/output/src3853497092/src/pages/plan-management/[id]/events/[eventId]/edit.vue?macro=true";
import { default as eventsLcBZ5Dpy_45Oa4_D22jXKbpOtCd2pMLMAbSfh2ETs6DcgMeta } from "/codebuild/output/src3853497092/src/pages/plan-management/[id]/events.vue?macro=true";
import { default as index8r8FlVY1MuWPVgobLrkk51oFKQ4_0vSeKWvTNR9UQ2gMeta } from "/codebuild/output/src3853497092/src/pages/templates/[id]/events/index.vue?macro=true";
import { default as createWq_1UZ8vHMBOWY91ykLCV6PJAQUKuju4sAZ_45xIv9LpcMeta } from "/codebuild/output/src3853497092/src/pages/trackers/[id]/events/create.vue?macro=true";
import { default as assign_45groupsld8Y_45kviBv08vRcMK_KxJNkkso3YFjaKXBxPU4yqo1wMeta } from "/codebuild/output/src3853497092/src/pages/templates/[id]/assign-groups.vue?macro=true";
import { default as createkrr8aMjGXt9g_45D1GQY12D4eE1x0ESH49rSume_45_EAqIMeta } from "/codebuild/output/src3853497092/src/pages/templates/[id]/events/create.vue?macro=true";
import { default as indexJUlrveUVy_457LjU2tJ2F1_72c2pqMIVV0waJXUUN65kkMeta } from "/codebuild/output/src3853497092/src/pages/trackers/[id]/transformers/index.vue?macro=true";
import { default as indexpdEM1o_SFjM5NIKR_TDNKe04S2h9KynEz5_fUeLuboQMeta } from "/codebuild/output/src3853497092/src/pages/templates/[id]/transformers/index.vue?macro=true";
import { default as createct8nC_d5PmwrcFHDdVnXKQ9oZ8iYuF0EGCCAd9jJ470Meta } from "/codebuild/output/src3853497092/src/pages/trackers/[id]/transformers/create.vue?macro=true";
import { default as retain_45backend7vUAkbXUeIXk9aNeZu_3xDYmjDAa0fxvcYo4bMcglaQMeta } from "/codebuild/output/src3853497092/src/pages/standalone-snowplow/retain-backend.vue?macro=true";
import { default as createstHdFz5KlwpGHeLyHATWRJs7Eeh_EZG2QARSC9B_fVwMeta } from "/codebuild/output/src3853497092/src/pages/templates/[id]/transformers/create.vue?macro=true";
import { default as retain_45frontendHnuFO_45gdjEakyJyFqQqG9dDy4_bga5o2rzIeI9PnjeMMeta } from "/codebuild/output/src3853497092/src/pages/standalone-snowplow/retain-frontend.vue?macro=true";
import { default as BaseSoftwarePagefkS3BwmnHrVZiGaBf8bO2ieyCyM_45TYPORvT6Ply7oRgMeta } from "/codebuild/output/src3853497092/src/pages/standalone-snowplow/BaseSoftwarePage.vue?macro=true";
import { default as indextq0xzSKb_45t1kSyZ1ICYUoi70jc4JulhV6fdUpVbLvIUMeta } from "/codebuild/output/src3853497092/src/pages/trackers/[id]/events/[eventId]/index.vue?macro=true";
import { default as indexHoPcvLIDh2Ee45ha0lvhxrsL_kuBJfMJODEQfaGc4akMeta } from "/codebuild/output/src3853497092/src/pages/templates/[id]/events/[eventId]/index.vue?macro=true";
import { default as netdirector_45ownershipTjZN4XFOrZs_45Q7z_B0jnz2ORE6c9GDgCMitfDj_pMbkMeta } from "/codebuild/output/src3853497092/src/pages/standalone-snowplow/netdirector-ownership.vue?macro=true";
import { default as index6P95Np1Ya3uG6cNcmZ_fcvIqZJbbVYto8qdfFjg7xIUMeta } from "/codebuild/output/src3853497092/src/pages/trackers/[id]/events/[eventId]/edit/index.vue?macro=true";
import { default as index9HtHMqPzzsUoupyf3_45p95mXpNQvQg077rmOohVbLpugMeta } from "/codebuild/output/src3853497092/src/pages/templates/[id]/events/[eventId]/edit/index.vue?macro=true";
import { default as jlr_45global_45avl_45frontendMcXav8hDiUxdLEbcO6cmRT50Nn1nvcYhWMd0GcvxvEYMeta } from "/codebuild/output/src3853497092/src/pages/standalone-snowplow/jlr-global-avl-frontend.vue?macro=true";
import { default as netdirector_45experience_45v22mri0P6VOBEqMFpefrRmS8xpi0fw_CQLtJKVcbeZ_454MMeta } from "/codebuild/output/src3853497092/src/pages/standalone-snowplow/netdirector-experience-v2.vue?macro=true";
import { default as editEL4qyAud4_45vH0qUjVwRTru_TCOHuNU_1omBaTXUOpEcMeta } from "/codebuild/output/src3853497092/src/pages/trackers/[id]/transformers/[transformerId]/edit.vue?macro=true";
import { default as editqL4NRMguIh_45_459UaVIiPuYYwIU0JUME13qvY2Y8qx65MMeta } from "/codebuild/output/src3853497092/src/pages/templates/[id]/transformers/[transformerId]/edit.vue?macro=true";
import { default as netdirector_45frontend_45componentsTompNJFqLHnJya897IIZM_45DeLXNZkw8aQ_453OUM6mAboMeta } from "/codebuild/output/src3853497092/src/pages/standalone-snowplow/netdirector-frontend-components.vue?macro=true";
import { default as netdirector_45online_45vehicle_45salesF2Q68ok5QNVPs4HVgWfd9lZR2onihCtKEk30rxKjH4YMeta } from "/codebuild/output/src3853497092/src/pages/standalone-snowplow/netdirector-online-vehicle-sales.vue?macro=true";
import { default as indexVcS1lO11ovBOHaulLB8pFSNUZTLX8lQqDhIdtfERXqUMeta } from "/codebuild/output/src3853497092/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue?macro=true";
import { default as indexUbkGQp_45tZLowb_45yhG2preXnZ0Bm2x_45WZArhVoeq6RZUMeta } from "/codebuild/output/src3853497092/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue?macro=true";
import { default as createmAa3_n_45IaqSEKQd8X5cFw6Qymc6BAmIx325JqHi7at0Meta } from "/codebuild/output/src3853497092/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue?macro=true";
import { default as createeziZuslNgcpbDdXssvYtbySZnE3SbaVec_4brqB482sMeta } from "/codebuild/output/src3853497092/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue?macro=true";
import { default as editnMI48f7qxlIslD_HvxbnEm61ZuuYAIK4CfP3dwi4oBQMeta } from "/codebuild/output/src3853497092/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue?macro=true";
import { default as editiRRXZsvCjDqMAUsY_A9RoYA0wwMwab9QluBEBua1X_458Meta } from "/codebuild/output/src3853497092/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3853497092/src/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: {"middleware":"auth"},
    component: () => import("/codebuild/output/src3853497092/src/pages/login/index.vue")
  },
  {
    name: "software",
    path: "/software",
    component: () => import("/codebuild/output/src3853497092/src/pages/software/index.vue")
  },
  {
    name: "trackers",
    path: "/trackers",
    component: () => import("/codebuild/output/src3853497092/src/pages/trackers/index.vue")
  },
  {
    name: "templates",
    path: "/templates",
    component: () => import("/codebuild/output/src3853497092/src/pages/templates/index.vue")
  },
  {
    name: "trackers-create",
    path: "/trackers/create",
    component: () => import("/codebuild/output/src3853497092/src/pages/trackers/create.vue")
  },
  {
    name: "templates-create",
    path: "/templates/create",
    component: () => import("/codebuild/output/src3853497092/src/pages/templates/create.vue")
  },
  {
    name: "tagging-docs",
    path: "/tagging-docs",
    component: () => import("/codebuild/output/src3853497092/src/pages/tagging-docs/index.vue")
  },
  {
    name: "trackers-id-edit",
    path: "/trackers/:id()/edit",
    component: () => import("/codebuild/output/src3853497092/src/pages/trackers/[id]/edit.vue")
  },
  {
    name: "login-token-token",
    path: "/login/token/:token()",
    component: () => import("/codebuild/output/src3853497092/src/pages/login/token/[token].vue")
  },
  {
    name: "templates-id-edit",
    path: "/templates/:id()/edit",
    component: () => import("/codebuild/output/src3853497092/src/pages/templates/[id]/edit.vue")
  },
  {
    name: "templates-id",
    path: "/templates/:id()",
    component: () => import("/codebuild/output/src3853497092/src/pages/templates/[id]/index.vue")
  },
  {
    name: "plan-management",
    path: "/plan-management",
    component: () => import("/codebuild/output/src3853497092/src/pages/plan-management/index.vue")
  },
  {
    name: "dropcode-generator",
    path: "/dropcode-generator",
    component: () => import("/codebuild/output/src3853497092/src/pages/dropcode-generator/index.vue")
  },
  {
    name: "standalone-snowplow",
    path: "/standalone-snowplow",
    component: () => import("/codebuild/output/src3853497092/src/pages/standalone-snowplow/index.vue")
  },
  {
    name: "trackers-id-events",
    path: "/trackers/:id()/events",
    component: () => import("/codebuild/output/src3853497092/src/pages/trackers/[id]/events/index.vue")
  },
  {
    name: eventsLcBZ5Dpy_45Oa4_D22jXKbpOtCd2pMLMAbSfh2ETs6DcgMeta?.name,
    path: "/plan-management/:id()/events",
    component: () => import("/codebuild/output/src3853497092/src/pages/plan-management/[id]/events.vue"),
    children: [
  {
    name: "plan-management-id-events",
    path: "",
    component: () => import("/codebuild/output/src3853497092/src/pages/plan-management/[id]/events/index.vue")
  },
  {
    name: "plan-management-id-events-create",
    path: "create",
    component: () => import("/codebuild/output/src3853497092/src/pages/plan-management/[id]/events/create.vue")
  },
  {
    name: "plan-management-id-events-eventId-edit",
    path: ":eventId()/edit",
    component: () => import("/codebuild/output/src3853497092/src/pages/plan-management/[id]/events/[eventId]/edit.vue")
  }
]
  },
  {
    name: "templates-id-events",
    path: "/templates/:id()/events",
    component: () => import("/codebuild/output/src3853497092/src/pages/templates/[id]/events/index.vue")
  },
  {
    name: "trackers-id-events-create",
    path: "/trackers/:id()/events/create",
    component: () => import("/codebuild/output/src3853497092/src/pages/trackers/[id]/events/create.vue")
  },
  {
    name: "templates-id-assign-groups",
    path: "/templates/:id()/assign-groups",
    component: () => import("/codebuild/output/src3853497092/src/pages/templates/[id]/assign-groups.vue")
  },
  {
    name: "templates-id-events-create",
    path: "/templates/:id()/events/create",
    component: () => import("/codebuild/output/src3853497092/src/pages/templates/[id]/events/create.vue")
  },
  {
    name: "trackers-id-transformers",
    path: "/trackers/:id()/transformers",
    component: () => import("/codebuild/output/src3853497092/src/pages/trackers/[id]/transformers/index.vue")
  },
  {
    name: "templates-id-transformers",
    path: "/templates/:id()/transformers",
    component: () => import("/codebuild/output/src3853497092/src/pages/templates/[id]/transformers/index.vue")
  },
  {
    name: "trackers-id-transformers-create",
    path: "/trackers/:id()/transformers/create",
    component: () => import("/codebuild/output/src3853497092/src/pages/trackers/[id]/transformers/create.vue")
  },
  {
    name: "standalone-snowplow-retain-backend",
    path: "/standalone-snowplow/retain-backend",
    component: () => import("/codebuild/output/src3853497092/src/pages/standalone-snowplow/retain-backend.vue")
  },
  {
    name: "templates-id-transformers-create",
    path: "/templates/:id()/transformers/create",
    component: () => import("/codebuild/output/src3853497092/src/pages/templates/[id]/transformers/create.vue")
  },
  {
    name: "standalone-snowplow-retain-frontend",
    path: "/standalone-snowplow/retain-frontend",
    component: () => import("/codebuild/output/src3853497092/src/pages/standalone-snowplow/retain-frontend.vue")
  },
  {
    name: "standalone-snowplow-BaseSoftwarePage",
    path: "/standalone-snowplow/BaseSoftwarePage",
    component: () => import("/codebuild/output/src3853497092/src/pages/standalone-snowplow/BaseSoftwarePage.vue")
  },
  {
    name: "trackers-id-events-eventId",
    path: "/trackers/:id()/events/:eventId()",
    component: () => import("/codebuild/output/src3853497092/src/pages/trackers/[id]/events/[eventId]/index.vue")
  },
  {
    name: "templates-id-events-eventId",
    path: "/templates/:id()/events/:eventId()",
    component: () => import("/codebuild/output/src3853497092/src/pages/templates/[id]/events/[eventId]/index.vue")
  },
  {
    name: "standalone-snowplow-netdirector-ownership",
    path: "/standalone-snowplow/netdirector-ownership",
    component: () => import("/codebuild/output/src3853497092/src/pages/standalone-snowplow/netdirector-ownership.vue")
  },
  {
    name: "trackers-id-events-eventId-edit",
    path: "/trackers/:id()/events/:eventId()/edit",
    component: () => import("/codebuild/output/src3853497092/src/pages/trackers/[id]/events/[eventId]/edit/index.vue")
  },
  {
    name: "templates-id-events-eventId-edit",
    path: "/templates/:id()/events/:eventId()/edit",
    component: () => import("/codebuild/output/src3853497092/src/pages/templates/[id]/events/[eventId]/edit/index.vue")
  },
  {
    name: "standalone-snowplow-jlr-global-avl-frontend",
    path: "/standalone-snowplow/jlr-global-avl-frontend",
    component: () => import("/codebuild/output/src3853497092/src/pages/standalone-snowplow/jlr-global-avl-frontend.vue")
  },
  {
    name: "standalone-snowplow-netdirector-experience-v2",
    path: "/standalone-snowplow/netdirector-experience-v2",
    component: () => import("/codebuild/output/src3853497092/src/pages/standalone-snowplow/netdirector-experience-v2.vue")
  },
  {
    name: "trackers-id-transformers-transformerId-edit",
    path: "/trackers/:id()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src3853497092/src/pages/trackers/[id]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "templates-id-transformers-transformerId-edit",
    path: "/templates/:id()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src3853497092/src/pages/templates/[id]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "standalone-snowplow-netdirector-frontend-components",
    path: "/standalone-snowplow/netdirector-frontend-components",
    component: () => import("/codebuild/output/src3853497092/src/pages/standalone-snowplow/netdirector-frontend-components.vue")
  },
  {
    name: "standalone-snowplow-netdirector-online-vehicle-sales",
    path: "/standalone-snowplow/netdirector-online-vehicle-sales",
    component: () => import("/codebuild/output/src3853497092/src/pages/standalone-snowplow/netdirector-online-vehicle-sales.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers",
    component: () => import("/codebuild/output/src3853497092/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers",
    component: () => import("/codebuild/output/src3853497092/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers-create",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/create",
    component: () => import("/codebuild/output/src3853497092/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers-create",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/create",
    component: () => import("/codebuild/output/src3853497092/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers-transformerId-edit",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src3853497092/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers-transformerId-edit",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src3853497092/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue")
  }
]